import { businessErrorFactory, BusinessError } from '../../../../common/business-error';

const GET_CREDIT_DETAILS_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and we could not get information about this credit. Please try again. If the problem still persists, contact with support.';

const OPERATION_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry, but we could not find information about this credit. Please refresh page and try again. If the problem still persists, contact with support.';

enum BUSINESS_ERRORS {
  'OPERATION_NOT_FOUND' = 'OPERATION_NOT_FOUND'
}

export const getCreditDetailsBusinessError = (businessError: BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case BUSINESS_ERRORS.OPERATION_NOT_FOUND: {
      return businessErrorFactory({ message: OPERATION_NOT_FOUND, severity: 'error' });
    }
    default: {
      return businessErrorFactory({
        message: GET_CREDIT_DETAILS_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};

const GET_CREDIT_HISTORY_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and we could not get information about your credit history. Please try again. If the problem still persists, contact with support.';

export const getCreditHistoryBusinessError = (businessError: unknown): BusinessError => {
  switch (businessError) {
    default: {
      return businessErrorFactory({
        message: GET_CREDIT_HISTORY_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
